module.exports = __webpack_public_path__ + "img/intersectional.66181206.png";